import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-padding vert uk-padding-remove-horizontal uk-position-relative mt-5" }
const _hoisted_2 = { class: "uk-container uk-container-large" }
const _hoisted_3 = { "data-uk-grid": "" }
const _hoisted_4 = { class: "uk-width-2-3@xl uk-width-2-3@l uk-width-2-3@m uk-width-1-1@s" }
const _hoisted_5 = { class: "impx-text-large" }
const _hoisted_6 = { class: "uk-text-bold" }
const _hoisted_7 = { class: "uk-text-bold" }
const _hoisted_8 = { class: "uk-text-bold" }
const _hoisted_9 = { class: "uk-margin-medium-bottom" }

import DetailsHeadingBloc from "@/views/booking/components/DetailsHeadingBloc.vue";
import DetailsImages from "@/views/booking/components/DetailsImages.vue";
import RoomKeyItem from "@/views/booking/components/RoomKeyItem.vue";
import CsaLocation from "@/views/about/CsaLocation.vue";
import DetailsBookingForm from "@/views/booking/components/DetailsBookingForm.vue";
import {useStore} from "vuex";
import Room from "@/models/Room";

export default /*@__PURE__*/_defineComponent({
  __name: 'ApartmentDetails',
  setup(__props) {


const store = useStore();
const roomChoose:Room = store.getters["room/getRoomChoose"];
console.log(roomChoose);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DetailsHeadingBloc),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(DetailsImages, {
            "room-pictures": _unref(roomChoose)?.room_photos??[]
          }, null, 8, ["room-pictures"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _cache[0] || (_cache[0] = _createTextVNode(" Appartement ", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(roomChoose).room_name), 1),
              _cache[1] || (_cache[1] = _createTextVNode(" - Type: ", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(roomChoose)?.room_type?.room_type_name??''), 1),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(roomChoose).room_total_price) + " FCFA/ Nuitée ", 1)
            ]),
            _createVNode(RoomKeyItem, {
              "room-spec": _unref(roomChoose)?.room_spec??[]
            }, null, 8, ["room-spec"]),
            _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Description", -1)),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(roomChoose).room_description??''), 1),
            _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "uk-divider-icon" }, null, -1))
          ]),
          _createVNode(DetailsBookingForm)
        ])
      ])
    ]),
    _createVNode(CsaLocation)
  ], 64))
}
}

})